/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable new-cap */
/* eslint-disable no-new */
/* eslint-disable no-undef */

import React, { useEffect, useRef } from 'react';
import { withPrefix } from 'gatsby';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import parse from 'html-react-parser';
import { fireResizeMessage } from '../global/ap-resize';
import { generateVideoEmbed } from '../../helpers/generate-video-embed';
import { scrollToPlusNav } from '../../helpers/scroll-to';
import { gtmPush } from '../global/gtm-push';
import './_single-event-full.scss';

const SingleEventFull = ({
  data, title, modalRef, setData, filterData, eventsData, embedded,
}) => {
  const eventData = data;
  const singleData = data.data;
  const standalone = !modalRef;
  const eventEl = useRef(null);
  const incidentDate = new Date(singleData.Incident_Date);
  incidentDate.setDate(incidentDate.getDate() + 1);
  const incidentDateStr = incidentDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  let embed = false;
  if (singleData.Main_Video && (singleData.Main_Video.includes('youtube') || singleData.Main_Video.includes('vimeo') || singleData.Main_Video?.includes('assets.headless.frol.us'))) {
    embed = generateVideoEmbed(singleData.Main_Video);
  }

  let externalUrl = '';
  if (typeof window !== 'undefined') {
    externalUrl = `${window.location.protocol}//${window.location.host}/`;
  }

  const onKeyPress = (e) => {
    if (e.keyCode === 27) {
      modalRef.current.closeModal();
    }
  };

  const handleUpdateFilter = (filterType, filter) => {
    const filteredData = filterData(eventsData, filterType, filter, true);
    setData(filteredData);
    const selectLocation = document.querySelector('.home__filter-categories select[name="location"]');
    const selectCategory = document.querySelector('.home__filter-categories select[name="category"]');
    const selectcivilian = document.querySelector('.home__filter-categories select[name="civilian"]');
    selectLocation.value = (filterType === 'location' ? filter : 'all');
    selectCategory.value = (filterType === 'category' ? filter : 'all');
    selectcivilian.value = (filterType === 'civilian' ? filter : 'all');
    scrollToPlusNav('.home__filter');
    modalRef.current.closeModal();
  };

  useEffect(() => {
    fireResizeMessage(true);
    const handler = (msg) => {
      if (msg.data?.currentScroll && msg.data?.currentScroll !== true) {
        const eventElHeight = eventEl.current.offsetHeight;
        const { currentScroll } = msg.data;
        if (document.documentElement.offsetHeight - eventElHeight < currentScroll
          && eventElHeight < document.documentElement.offsetHeight) {
          eventEl.current.style.marginTop = `${document.documentElement.offsetHeight - eventElHeight}px`;
        } else {
          eventEl.current.style.marginTop = `${currentScroll}px`;
        }
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);
  useEffect(() => {
    gtmPush(
      'load full event',
      eventData.fields.slug,
    );
  }, []);
  return (
    <div className={`event ${(standalone ? 'event--standalone' : 'event--modal')}`} ref={eventEl}>
      {(standalone ? (
        <a href={withPrefix('/')} className="event__back">
          Home
        </a>
      ) : (
        <span className="event__back" onClick={() => modalRef.current.closeModal()} onKeyPress={() => onKeyPress(e)} role="button" tabIndex="-1">
          Home
        </span>
      ))}
      {(standalone ? (
        <a href="/" className="event__suphead">
          {title}
        </a>
      ) : (
        <span className="event__suphead" onClick={() => modalRef.current.closeModal()} onKeyPress={() => onKeyPress(e)} role="button" tabIndex="0">
          {title}
        </span>
      ))}

      <div className="event__heading">
        <h3>{singleData.Publish_Title}</h3>
        <div className="event__date">
          {incidentDateStr}
        </div>
      </div>
      <div className="event__main">
        <div className="event__main-content">
          {(embed ? parse(embed) : false)}
          {(eventData.fields.localMainImage && !embed ? (
            <div className="event__image">
              <GatsbyImage image={eventData.fields.localMainImage.childImageSharp.gatsbyImageData} alt="" />
            </div>
          ) : false)}
          {((embed || eventData.fields.localMainImage) && singleData.Main_Media_Credit ? (
            <div className="event__credit">
              {singleData.Main_Media_Credit}
            </div>
          ) : false)}
          <div className="event__summary">
            {singleData.Publish_Description}
          </div>
          {(singleData.RelatedStories ? (
            <div className="event__related">
              <h4>Related Stories</h4>
              <ul>
                {singleData.RelatedStories.map((item, index) => (
                  (item.data.Related_URL && item.data.Related_Title ? (
                    <li>
                      <a href={item.data.Related_URL} target="_blank" rel="noreferrer" key={index}>
                        <p>
                          {item.data.Related_Title}
                        </p>
                      </a>
                      <p>{item.data.Source}</p>
                    </li>
                  ) : false)
                ))}
              </ul>
            </div>
          ) : false)}
        </div>
        <div className="event__main-sidebar">
          {(singleData.Warcrime_Category !== null ? (
            <div>
              <h6>War Crime Type:</h6>
              <ul>
                {singleData.Warcrime_Category.map((category, index) => (
                  (standalone || embedded ? (
                    <li key={index}><a className="event__action" href={`${externalUrl}?facets=|${category}|#tracker`} target={(embedded ? '_blank' : '_self')} rel="noreferrer">{category}</a></li>
                  ) : (
                    <li key={index}><span className="event__action" onClick={() => handleUpdateFilter('category', category)} role="button" tabIndex="0">{category}</span></li>
                  ))
                ))}
              </ul>
            </div>
          ) : false)}
          {(singleData.Location ? (
            <div>
              <h6>Location:</h6>
              <ul>
                <li>
                  {(standalone || embedded ? (
                    <a className="event__action" href={`${externalUrl}?facets=${eventData.location}||#tracker`} target={(embedded ? '_blank' : '_self')} rel="noreferrer">{singleData.Location}</a>
                  ) : (
                    <span className="event__action" onClick={() => handleUpdateFilter('location', singleData.Location)} role="button" tabIndex="0">{singleData.Location}</span>
                  ))}
                </li>
              </ul>
            </div>
          ) : false)}
          {(singleData.Warcrime_Facet !== null ? (
            <div>
              <h6>Additional Filters:</h6>
              <ul>
                {singleData.Warcrime_Facet.map((facet, index) => (
                  (standalone || embedded ? (
                    <li key={index}><a className="event__action" href={`${externalUrl}?facets=||${facet}#tracker`} target={(embedded ? '_blank' : '_self')} rel="noreferrer">{facet}</a></li>
                  ) : (
                    <li key={index}><span className="event__action" onClick={() => handleUpdateFilter('civilian', facet)} role="button" tabIndex="0">{facet}</span></li>
                  ))
                ))}
              </ul>
            </div>
          ) : false)}
        </div>
      </div>
      {(standalone ? (
        <a href={withPrefix('/')} className="event__button">
          All Attacks
        </a>
      ) : (
        <span className="event__button" onClick={() => modalRef.current.closeModal()} onKeyPress={() => onKeyPress(e)} role="button" tabIndex="0">
          All Attacks
        </span>
      ))}

    </div>
  );
};

export default SingleEventFull;

SingleEventFull.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  modalRef: PropTypes.object.isRequired,
  filterData: PropTypes.func,
  eventsData: PropTypes.object,
  setData: PropTypes.func,
  embedded: PropTypes.bool,
};

SingleEventFull.defaultProps = {
  filterData: (() => null),
  eventsData: {},
  setData: (() => null),
  embedded: false,
};
